"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organicReplicaSpiClient = void 0;
require("@redbox-ruby/data-lib");
const data_lib_1 = require("@redbox-ruby/data-lib");
function organicReplicaSpiClient(networkClient) {
    return {
        sendOrganicKeywordUpdate: (message) => {
            networkClient.fireToTopic(data_lib_1.SUBMIT_ORGANIC_REPLICA_UPDATE_TOPIC, message, "Unable to send organic update message, error=");
        },
        getAllKeywordRankKeywords: () => {
            return networkClient.getHttp(data_lib_1.ORGANIC_REPLICA_WEB_SERVICE, `/spi/v2/organic-replica/all-keywords-ranks`);
        },
        getAllKeywordSearchScoreKeywords: () => {
            return networkClient.getHttp(data_lib_1.ORGANIC_REPLICA_WEB_SERVICE, `/spi/v2/organic-replica/all-keyword-search-scores`);
        },
    };
}
exports.organicReplicaSpiClient = organicReplicaSpiClient;
